import constants, {
  HTTP_METHODS
} from "../../../settings/shared/constants";

import axiosClient from "../../common";


function constructHeader() {
  return {
    "Content-Type": "application/json"
  };
}


function buildApprovalUrl(
  requestId,
  action,
  token
) {
  return (
    constants.api.workflow.approval
    + "/"
    + encodeURIComponent(requestId)
    + "/"
    + action
    + "?token="
    + encodeURIComponent(token)
  );
}


function approve(requestId, token) {
  return axiosClient({
    url: buildApprovalUrl(
      requestId,
      "approve",
      token
    ),
    method: HTTP_METHODS.GET,
    headers: constructHeader()
  });
}


function reject(requestId, token) {
  return axiosClient({
    url: buildApprovalUrl(
      requestId,
      "reject",
      token
    ),
    method: HTTP_METHODS.GET,
    headers: constructHeader()
  });
}


const ApprovalService = {
  approve,
  reject
};

export default ApprovalService;